import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';
import Router from './routes';
import SnackbarProvider from './reuseable-components/snackbar/Snackbar';
import ThemeProvider from './theme/ThemeProvider';
import { UserProvider } from './context/UserProvider';
import { WindowSizeProvider } from './context/WindowSizeProvider';

/* eslint-disable import/no-unresolved */
import 'yet-another-react-lightbox/styles.css';
import 'yet-another-react-lightbox/plugins/captions.css';
import 'yet-another-react-lightbox/plugins/thumbnails.css';
import './theme/AGGridCSS.css';


export default function App() {
  const baseUrl = document.getElementsByTagName('base')[0]?.getAttribute('href');
  ModuleRegistry.registerModules([AllCommunityModule]);

  return (
    <HelmetProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <BrowserRouter baseUrl={baseUrl}>
          <ThemeProvider>
            <SnackbarProvider>
                <WindowSizeProvider>
              <UserProvider>
                  <Router />
              </UserProvider>
                </WindowSizeProvider>
            </SnackbarProvider>
          </ThemeProvider>
        </BrowserRouter>
      </LocalizationProvider>
    </HelmetProvider>
  );
}